// extracted by mini-css-extract-plugin
module.exports = {"iframe":"IFrameResizer__iframe"};